// extracted by mini-css-extract-plugin
export default {"submitButton":"UniversalSubmitButton_submitButton__3VB+c"};